/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Roles_User_GroupInputs */

const en_forms_roles_user_group = /** @type {(inputs: Forms_Roles_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronized User Group`)
};

const de_forms_roles_user_group = /** @type {(inputs: Forms_Roles_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierte Benutzergruppe`)
};

/**
* | output |
* | --- |
* | "Synchronized User Group" |
*
* @param {Forms_Roles_User_GroupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_roles_user_group = /** @type {((inputs?: Forms_Roles_User_GroupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Roles_User_GroupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_roles_user_group(inputs)
	return de_forms_roles_user_group(inputs)
});